// extracted by mini-css-extract-plugin
export default {"charts":"Widgets_charts__D9SQ8","widgets":"Widgets_widgets__jT2vc","donut":"Widgets_donut__AxkEB"};